/** Minimum heading field size in CSS px — shared by HTML preview and PDF. */
export const FIELDS_HEADING_MIN_FONT_SIZE_PX = 18;

/** Heading letter-spacing as em ratio (0.04em in preview → multiply by font size in pt for PDF). */
export const FIELDS_HEADING_LETTER_SPACING_EM = 0.04;

export function fieldsHeadingFontSizePx(blockFontSize: number): number {
  return Math.max(blockFontSize, FIELDS_HEADING_MIN_FONT_SIZE_PX);
}

export function fieldsHeadingLetterSpacingPt(fontSizePt: number): number {
  return fontSizePt * FIELDS_HEADING_LETTER_SPACING_EM;
}
